/**
 * desabilitando logs quando em produção (ignorando versões "stage")
 */
// if (process.env.REACT_APP_ENV === 'production') {
// console.log = console.warn = () => 0;
// }

import("./startup.js");
